import "../scss/template.scss";
import { ComponentsLib } from "../../../Common Javascript Files/components-library";
import { Carousel } from "./carousel";
import "jquery-mask-plugin";

export namespace Core {
    export class CoreFunction {
        init() {
            this.initModuleLoader();

            const inputsMasking: ComponentsLib.IMaskInput = new ComponentsLib.MaskInput();
            inputsMasking.handleDynamicCountry($("#checkout-form"));         

            $("[data-carousel]").each((index, item) => {
                const carousel: Carousel.ITopCarousel = new Carousel.TopCarousel();
                carousel.init(item);
            });

            const datePanel: ComponentsLib.IDatePanel = new ComponentsLib.DatePanel();
            datePanel.init();

            const radioSelector: ComponentsLib.IRadioSelector = new ComponentsLib.RadioSelector("[data-radio-selector=true]");
            radioSelector.init();

            const lightbox: ComponentsLib.ILightbox = new ComponentsLib.Lightbox("[data-lightbox-href]", "[data-lightbox-white-list]");
            lightbox.init();

            const emptyButton: ComponentsLib.IEmptyTextButton = new ComponentsLib.EmptyTextButton();
            emptyButton.init();

            const toggleCheckbox: ComponentsLib.IToggleCheckbox = new ComponentsLib.ToggleCheckbox("[data-toggle-target]");
            toggleCheckbox.init();


            const messagePanelResultAction = (data: boolean, messagePanel: JQuery) => {
                if (data) {
                    messagePanel.slideDown();
                } else {
                    messagePanel.slideUp();
                }
            }
            const messagePanel: ComponentsLib.IMessagePanel =
                new ComponentsLib.MessagePanel($("[data-message=true]"), messagePanelResultAction);
            messagePanel.init();

            const infoLabelResultAction = (data: string, messagePanel: JQuery) => {
                if (data) {
                    messagePanel.text(data);
                } else {
                    messagePanel.text("");
                }
            }

            const infoLabelPostCode: ComponentsLib.IMessagePanel =
                new ComponentsLib.MessagePanel($("[data-info-label='postCode']"), infoLabelResultAction);
            infoLabelPostCode.init();
            const infoLabelDeliveryPostCode: ComponentsLib.IMessagePanel =
                new ComponentsLib.MessagePanel($("[data-info-label='deliveryPostCode']"), infoLabelResultAction);
            infoLabelDeliveryPostCode.init();
        }

        async initModuleLoader() {
            try {
                const modulesModule = await import(/* webpackChunkName: "site-modules" */"./site-modules");
                new modulesModule.Modules.Loader().init();
            } catch (err) {
                console.error("Unable to load 'siteModulesJs'.", err);
            }
        }
    }
}
